import { render, staticRenderFns } from "./TicketsPage.vue?vue&type=template&id=3702e8fe&"
import script from "./TicketsPage.vue?vue&type=script&lang=js&"
export * from "./TicketsPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketsPage.vue?vue&type=style&index=0&id=3702e8fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports